export default __webpack_public_path__ + "2602b656090975e0f8e7ea10c09d3d80.png";